export default __webpack_public_path__ + "static/media/gowrav.f2e6cca2.jpeg";